// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__1Wfbn","expanded":"styles_expanded__2_rDB"};